module.exports = __webpack_public_path__ + "static/media/SFiOBOA_bm_sekundærlogo_sentrert_logo_neg.af48400b.svg";